import Lottie from 'lottie-react';

import faceTalkingSad from '../jsons/Face_Talking_Sad.json';

const FaceTalkingSad = props => {
  return <Lottie animationData={faceTalkingSad} {...props} />;
};

export default FaceTalkingSad;
